import { FC } from 'react'

export const GenericAppLogo: FC = () => (
  <svg
    data-testid="consent.generic-client-logo"
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 24 24"
    role="img"
    aria-label="Application"
  >
    <title>stack-perspective</title>
    <g fill="none">
      <path
        fill="url(#1752500502804-4744372_stack-perspective_existing_0_9j5b6fsew)"
        d="M7 7.748c0-2.317 0-3.475.475-4.29a3.5 3.5 0 0 1 1.853-1.539c.89-.316 2.027-.102 4.304.325l4.147.777c1.858.348 2.787.523 3.483 1a4 4 0 0 1 1.397 1.684C23 6.476 23 7.42 23 9.312v3.94c0 2.317 0 3.475-.475 4.29a3.5 3.5 0 0 1-1.853 1.539c-.89.316-2.027.102-4.304-.325l-4.147-.777c-1.858-.348-2.787-.523-3.483-1a4 4 0 0 1-1.397-1.684C7 14.524 7 13.58 7 11.688v-3.94Z"
        data-glass="origin"
        mask="url(#1752500502804-4744372_stack-perspective_mask_npad53mc0)"
      />
      <path
        fill="url(#1752500502804-4744372_stack-perspective_existing_0_9j5b6fsew)"
        d="M7 7.748c0-2.317 0-3.475.475-4.29a3.5 3.5 0 0 1 1.853-1.539c.89-.316 2.027-.102 4.304.325l4.147.777c1.858.348 2.787.523 3.483 1a4 4 0 0 1 1.397 1.684C23 6.476 23 7.42 23 9.312v3.94c0 2.317 0 3.475-.475 4.29a3.5 3.5 0 0 1-1.853 1.539c-.89.316-2.027.102-4.304-.325l-4.147-.777c-1.858-.348-2.787-.523-3.483-1a4 4 0 0 1-1.397-1.684C7 14.524 7 13.58 7 11.688v-3.94Z"
        clipPath="url(#1752500502804-4744372_stack-perspective_clipPath_92jk82aca)"
        data-glass="clone"
        filter="url(#1752500502804-4744372_stack-perspective_filter_ql7gyis96)"
      />
      <path
        fill="url(#1752500502804-4744372_stack-perspective_existing_1_4m8a1fwmn)"
        d="M1 10.748c0-2.317 0-3.475.475-4.29a3.5 3.5 0 0 1 1.853-1.539c.89-.316 2.028-.102 4.304.325l4.147.777c1.858.348 2.787.523 3.483 1a4 4 0 0 1 1.397 1.684C17 9.476 17 10.42 17 12.312v3.94c0 2.317 0 3.475-.475 4.29a3.5 3.5 0 0 1-1.853 1.539c-.89.316-2.027.102-4.304-.325l-4.147-.777c-1.858-.348-2.787-.523-3.483-1a4 4 0 0 1-1.397-1.684C1 17.524 1 16.58 1 14.688v-3.94Z"
        data-glass="blur"
      />
      <path
        fill="url(#1752500502804-4744372_stack-perspective_existing_2_gj8gaetpw)"
        d="M1 14.688v-3.94c0-2.171 0-3.326.39-4.134l.085-.157a3.5 3.5 0 0 1 1.566-1.42l.287-.118c.89-.316 2.028-.103 4.304.324l4.147.778c1.858.349 2.787.523 3.483 1a4.001 4.001 0 0 1 1.397 1.684c.34.772.341 1.717.341 3.607v3.94c0 2.316 0 3.475-.475 4.291l-.167.26a3.502 3.502 0 0 1-1.686 1.278l-.17.053c-.635.172-1.414.104-2.626-.103l-1.508-.274-4.147-.779c-1.742-.326-2.668-.499-3.35-.913l-.133-.085a4 4 0 0 1-1.276-1.434l-.121-.251c-.255-.579-.32-1.255-.336-2.354L1 14.688Zm.75 0c0 .957 0 1.633.04 2.167.04.525.114.86.236 1.137a3.252 3.252 0 0 0 1.136 1.368c.25.172.565.307 1.074.443.518.138 1.183.263 2.122.44l4.148.777c1.151.215 1.968.368 2.608.431.633.063 1.013.027 1.307-.077a2.751 2.751 0 0 0 1.456-1.209c.157-.27.261-.636.316-1.27.056-.641.057-1.472.057-2.643v-3.94c0-.957 0-1.633-.04-2.167-.04-.525-.114-.86-.236-1.137a3.251 3.251 0 0 0-1.136-1.368c-.25-.172-.565-.307-1.074-.443-.518-.138-1.183-.263-2.122-.44L7.494 5.98c-1.151-.215-1.968-.368-2.608-.431-.634-.063-1.013-.027-1.307.077a2.75 2.75 0 0 0-1.456 1.209c-.157.27-.261.636-.316 1.27-.056.641-.057 1.472-.057 2.643v3.94Z"
      />
      <defs>
        <linearGradient
          id="1752500502804-4744372_stack-perspective_existing_0_9j5b6fsew"
          x1={15}
          x2={15}
          y1={1}
          y2={20}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#575757" />
          <stop offset={1} stopColor="#151515" />
        </linearGradient>
        <linearGradient
          id="1752500502804-4744372_stack-perspective_existing_1_4m8a1fwmn"
          x1={9}
          x2={9}
          y1={4}
          y2={23}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3E3E5" stopOpacity={0.6} />
          <stop offset={1} stopColor="#BBBBC0" stopOpacity={0.6} />
        </linearGradient>
        <linearGradient
          id="1752500502804-4744372_stack-perspective_existing_2_gj8gaetpw"
          x1={9}
          x2={9}
          y1={4.768}
          y2={14.881}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </linearGradient>
        <clipPath id="1752500502804-4744372_stack-perspective_clipPath_92jk82aca">
          <path
            fill="url(#1752500502804-4744372_stack-perspective_existing_1_4m8a1fwmn)"
            d="M1 10.748c0-2.317 0-3.475.475-4.29a3.5 3.5 0 0 1 1.853-1.539c.89-.316 2.028-.102 4.304.325l4.147.777c1.858.348 2.787.523 3.483 1a4 4 0 0 1 1.397 1.684C17 9.476 17 10.42 17 12.312v3.94c0 2.317 0 3.475-.475 4.29a3.5 3.5 0 0 1-1.853 1.539c-.89.316-2.027.102-4.304-.325l-4.147-.777c-1.858-.348-2.787-.523-3.483-1a4 4 0 0 1-1.397-1.684C1 17.524 1 16.58 1 14.688v-3.94Z"
          />
        </clipPath>
        <filter
          id="1752500502804-4744372_stack-perspective_filter_ql7gyis96"
          width="400%"
          height="400%"
          x="-100%"
          y="-100%"
          filterUnits="objectBoundingBox"
          primitiveUnits="userSpaceOnUse"
        >
          <feGaussianBlur
            width="100%"
            height="100%"
            x="0%"
            y="0%"
            in="SourceGraphic"
            result="blur"
            stdDeviation={2}
          />
        </filter>
        <mask id="1752500502804-4744372_stack-perspective_mask_npad53mc0">
          <rect width="100%" height="100%" fill="#FFF" />
          <path
            fill="#000"
            d="M1 10.748c0-2.317 0-3.475.475-4.29a3.5 3.5 0 0 1 1.853-1.539c.89-.316 2.028-.102 4.304.325l4.147.777c1.858.348 2.787.523 3.483 1a4 4 0 0 1 1.397 1.684C17 9.476 17 10.42 17 12.312v3.94c0 2.317 0 3.475-.475 4.29a3.5 3.5 0 0 1-1.853 1.539c-.89.316-2.027.102-4.304-.325l-4.147-.777c-1.858-.348-2.787-.523-3.483-1a4 4 0 0 1-1.397-1.684C1 17.524 1 16.58 1 14.688v-3.94Z"
          />
        </mask>
      </defs>
    </g>
  </svg>
)
